import { generateApiReducer } from '@core/ngrx';
import {
  emobilityActions,
  paymentDetailsFormId,
} from '@innogy/emobility-shared';
import type { CollectionState } from '@innogy/utils-state';
import { createFeatureSelector, type ActionReducerMap } from '@ngrx/store';
import type {
  GetEmobilityProductsV2Response,
  GetExternalLeadResponse,
  ProductSelection,
} from '@integration/api-client/emobility';

import {
  chargeCardTypeFormId,
  chargeCardTypeReducer,
  type ChargeCardTypeState,
} from './lead-form-charge-card-type.reducer';
import {
  chargePointConfigurationFormId,
  chargePointConfigurationReducer,
  type ChargePointConfigurationState,
} from './lead-form-charge-point-configuration.reducer';
import type { CustomerDetailsState } from './lead-form-customer-details.reducer';
import {
  customerDetailsFormId,
  customerDetailsReducer,
} from './lead-form-customer-details.reducer';
import type { LeadAddressFormState } from './lead-form.address.reducer';
import {
  createLeadFormAddressReducer,
  installationAddressFormId,
} from './lead-form.address.reducer';
import type { LeadConsentsFormState } from './lead-form.consents.reducer';
import {
  leadConsentsFormId,
  leadConsentsReducer,
} from './lead-form.consents.reducer';
import {
  leadFormPaymentDetailsReducer,
  type LeadFormsPaymentDetailsFormState,
} from './lead-form-payment-details.reducer';

export const leadFormSelectorKey = 'emobility-lead-form';

export interface LeadFormQueryParams {
  propositie?: ProductSelection;
  laadpaal?: string | 'nee' | 'onbekend';
  laadpas?: 'ja' | 'nee' | 'onbekend';
  zakelijk?: 'ja' | 'nee' | 'onbekend';
}

export interface LeadFormState {
  readonly [customerDetailsFormId]: CustomerDetailsState;
  readonly [installationAddressFormId]: LeadAddressFormState;
  readonly [paymentDetailsFormId]: LeadFormsPaymentDetailsFormState;
  readonly [leadConsentsFormId]: LeadConsentsFormState;
  readonly [chargeCardTypeFormId]: ChargeCardTypeState;
  readonly [chargePointConfigurationFormId]: ChargePointConfigurationState;
  readonly prospect: CollectionState<GetExternalLeadResponse>;
  readonly products: CollectionState<GetEmobilityProductsV2Response>;
}

export const leadFormReducers: ActionReducerMap<LeadFormState> = {
  products: generateApiReducer(emobilityActions.getEmobilityProductsV2),
  prospect: generateApiReducer(emobilityActions.getSalesPartnerProspectV1),
  [customerDetailsFormId]: customerDetailsReducer,
  [installationAddressFormId]: createLeadFormAddressReducer(
    installationAddressFormId
  ),
  [paymentDetailsFormId]: leadFormPaymentDetailsReducer,
  [leadConsentsFormId]: leadConsentsReducer,
  [chargeCardTypeFormId]: chargeCardTypeReducer,
  [chargePointConfigurationFormId]: chargePointConfigurationReducer,
};

export const emobilityLeadFormFeature =
  createFeatureSelector<LeadFormState>(leadFormSelectorKey);
